// redux/specialist-slices/appointments.slice.js
import { asyncThunkWrapper } from "../thunkHandler";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BASEURI, headers } from "../../utils/helper";




// Retrieve all appointments for specialist
export const handleRetrieveSpecialistAppointments = createAsyncThunk(
    "retrieveAll",
    async (data, thunkAPI) => {
        const params = {
            type: data?.type || "pending",
            limit: data?.limit || 10,
            currentPage: data?.currentPage || null,
            date: data?.date || null,
            search: data?.search || "",         
            startDate: data?.startDate || null,  
            endDate: data?.endDate || null,
            status: data?.status || null,
        };

        return asyncThunkWrapper(
            {
                params,
                method: "GET",
                headers: headers(),
                url: `${BASEURI}/specialist/appointments/retrieve-all`,
            },
            thunkAPI,
            {
                toast: false,
            }
        );
    }
);





// Accept appointment
export const handleAcceptAppointment = createAsyncThunk(
    "accept",
    async (appointmentId, thunkAPI) => {
        return asyncThunkWrapper(
            {
                method: "PUT",
                headers: headers(),
                url: `${BASEURI}/specialist/appointments/accept/${appointmentId}`,
            },
            thunkAPI
        );
    }
);

// Reject appointment
export const handleRejectAppointment = createAsyncThunk(
    "reject",
    async (data, thunkAPI) => {
        return asyncThunkWrapper(
            {
                data: { rejectReason: data.rejectReason },
                method: "PUT",
                headers: headers(),
                url: `${BASEURI}/specialist/appointments/reject/${data.appointmentId}`,
            },
            thunkAPI
        );
    }
);

